import { lazy } from "react";
import Loadable from "app/components/Loadable";

const ManageUri = Loadable(lazy(() => import("./ManageUriList")));
const ManageUriEdit = Loadable(lazy(() => import("./ManageUriAdd")));

const ManageUriRoutes = [
  { path: "/app/manage-uri", element: <ManageUri /> },
  { path: "/app/manage-uri/:mode/:id", element: <ManageUriEdit /> },
];

export default ManageUriRoutes;
